import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Loader2, AlertCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { FadeUp } from "@/components/Reveal";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("loading");
  const { clear } = useCart();

  useEffect(() => {
    document.title = "Ordine confermato — Luca Mannu Giardini";
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          clear();
          return;
        }
      } catch { /* riprova */ }
      if (++attempts < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col items-start justify-center px-6 py-40" data-testid="payment-success-page">
      <FadeUp>
        {state === "loading" && (
          <>
            <Loader2 className="h-10 w-10 animate-spin text-moss" strokeWidth={1.5} />
            <h1 className="mt-8 font-serif text-4xl text-forest" data-testid="payment-status-title">Conferma del pagamento in corso…</h1>
            <p className="mt-4 text-sage">Stiamo verificando il tuo ordine con Stripe. Qualche secondo.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-moss/15">
              <Check className="h-8 w-8 text-moss" strokeWidth={1.5} />
            </span>
            <h1 className="mt-8 font-serif text-5xl tracking-tight text-forest" data-testid="payment-status-title">Grazie per il tuo ordine.</h1>
            <p className="mt-4 max-w-md leading-relaxed text-sage">
              Il pagamento è andato a buon fine. Riceverai una conferma via email e ti contatterò per concordare la consegna.
            </p>
            <Link to="/negozio" data-testid="payment-continue-shopping" className="mt-10 inline-block rounded-full bg-forest px-10 py-4 font-accent text-sm uppercase tracking-[0.2em] text-bone transition-transform duration-300 hover:scale-105 active:scale-95">
              Torna al negozio
            </Link>
          </>
        )}
        {(state === "timeout" || state === "error") && (
          <>
            <AlertCircle className="h-10 w-10 text-terra" strokeWidth={1.5} />
            <h1 className="mt-8 font-serif text-4xl text-forest" data-testid="payment-status-title">Verifica non riuscita</h1>
            <p className="mt-4 max-w-md leading-relaxed text-sage">
              Non sono riuscito a confermare il pagamento. Se l'addebito è avvenuto, l'ordine verrà comunque registrato a breve. Per dubbi scrivimi a info@lucamannugiardini.it.
            </p>
            <Link to="/negozio" data-testid="payment-back-shop" className="link-underline mt-8 inline-block font-accent text-xs uppercase tracking-[0.2em] text-terra">
              Torna al negozio
            </Link>
          </>
        )}
      </FadeUp>
    </main>
  );
}
